/**
 * Code Table Categories for Monolith Lookup System
 * 
 * These are the category strings used to query the monolith code table API.
 * Each constant maps to a specific code table category in the monolith system.
 * 
 * For Engagement API lookup categories, see @/lib/constants/engagement-codes
 */

export const CODE_TABLE_CATEGORIES = {
  CURRENCY: "geo.CodeCurrency",
  SUBDIVISION: "geo.CodeSubdivision",
  RATE_UNIT: "workorder.CodeRateUnit",
  RATE_TYPE: "workorder.CodeRateType",
  PAYMENT_SCHEDULE: "workorder.CodePaymentReleaseSchedule",
  TIMESHEET_CYCLE: "workorder.CodeTimeSheetCycle",
  APPROVAL_FLOW: "workorder.CodeTimeSheetApprovalFlow",
  BILLING_FREQUENCY: "workorder.CodeBillingFrequency",
  PAYMENT_TERMS: "workorder.CodeBillingInvoiceTerms",
  INVOICE_TEMPLATE: "workorder.CodeBillingInvoiceTemplate",
  DELIVERY_METHOD: "workorder.CodeDeliveryMethod",
  BRANCH: "workorder.CodeInternalOrganizationDefinition1"
} as const

